import react from "react";
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <header>
            <h1>
                Website
            </h1>
            <nav>
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/about">About</Link>
                    </li>
                    <li>
                        <Link to="/contact">Contact</Link>
                    </li>
                    <li>
                        <Link to="/faq">FAQ</Link>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;